import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DsBoxModule } from '@bmw-ds/components';

import { FoundCustomer } from '../../../../../customer/model/found-customer.model';
import { useI18n } from '../../../../../i18n/services/i18n.service';
import { SearchResultMode } from '../../model/search-result-mode.model';
import { NoSearchResultsComponent } from '../no-search-results/no-search-results.component';
import { ValidSearchResultsComponent } from '../valid-search-results/valid-search-results.component';

@Component({
  selector: 'cdf-search-results',
  imports: [DsBoxModule, ValidSearchResultsComponent, NoSearchResultsComponent],
  template: `
    @if (searchResults() !== undefined) {
      <h2>
        {{ i18n('searchResults.searchResults') }}
        <span class="title-xs text-neutral">{{ i18n('results', { count: resultCount() }) }}</span>
      </h2>
      @if (activeAdminDpNr()) {
        <div id="selected-admin-dp-section">
          <span class="title-xs text-neutral">{{ i18n('adminMode.usedDpNrForSearch') }}: </span>
          <span class="text-neutral title-sm">{{ activeAdminDpNr() }}</span>
        </div>
      }
      @if (noResults()) {
        <cdf-no-search-results
          class="my-4x"
          [searchResultMode]="searchResultMode()"
          [readonly]="readonly()"
          (createNewCustomer)="createNewCustomer.emit()"
        />
      } @else {
        <cdf-valid-search-results
          [searchResults]="searchResults()"
          [loadingCustomer]="loadingCustomer()"
          [searchResultMode]="searchResultMode()"
          [readonly]="readonly()"
          (createNewCustomer)="createNewCustomer.emit()"
          (openCustomerProfile)="openCustomerProfile.emit($event)"
        />
      }
    }
  `,
  styleUrl: './search-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsComponent {
  protected readonly i18n = useI18n();

  /**
   * Describes which customers profile is currently being opened and should display a loading state
   */
  readonly loadingCustomer = input<FoundCustomer | undefined>();

  readonly searchResults = input.required<FoundCustomer[] | undefined>();
  readonly searchResultMode = input<SearchResultMode>(SearchResultMode.CUSTOMER_SEARCH);
  readonly readonly = input(false);

  /**
   * The dpNr chosen by a user using the admin mode
   */
  readonly activeAdminDpNr = input<string | undefined>();

  readonly openCustomerProfile = output<FoundCustomer>();
  readonly createNewCustomer = output();

  protected readonly resultCount = computed(() => this.searchResults()?.length ?? 0);
  protected readonly noResults = computed(() => this.resultCount() === 0);
}
